// extracted by mini-css-extract-plugin
module.exports = {"container":"Account_container__3-3oP","breadcrumbs":"Account_breadcrumbs__3d62-","content":"Account_content__a4LvW"};